import { render, staticRenderFns } from "./spams.vue?vue&type=template&id=ccf0ec60&scoped=true&"
import script from "./spams.vue?vue&type=script&lang=js&"
export * from "./spams.vue?vue&type=script&lang=js&"
import style0 from "./spams.vue?vue&type=style&index=0&id=ccf0ec60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccf0ec60",
  null
  
)

component.options.__file = "spams.vue"
export default component.exports